const clearFilterButton = {
  Typography: 'Clear'
};

export default clearFilterButton;
